<div [formGroup]="formGroup">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Column</mat-label>
    <mat-select formControlName="column">
      <mat-option *ngFor="let column of state.columns; trackBy: trackByColumn" [value]="column.column">
        <y42-column-type-icon *ngIf="column.type" [type]="column.type"></y42-column-type-icon>
        {{ column.column }}
      </mat-option>
      <mat-select-trigger>
        <ng-container *ngIf="state.selectedColumnType as type">
          <y42-column-type-icon [type]="type"></y42-column-type-icon>
        </ng-container>
        {{ formGroup.controls.column.value }}
      </mat-select-trigger>
    </mat-select>
    <mat-error *ngIf="formGroup.controls.column.errors?.required">Please select a column</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Allow Null Values</mat-label>
    <mat-select formControlName="allow_null_values">
      <mat-option [value]="true"><span class="text-green-700">TRUE</span></mat-option>
      <mat-option [value]="false"><span class="text-red-700">FALSE</span></mat-option>
      <mat-select-trigger>
        <span class="text-green-700" *ngIf="formGroup.controls.allow_null_values.value">TRUE</span>
        <span class="text-red-700" *ngIf="!formGroup.controls.allow_null_values.value">FALSE</span>
      </mat-select-trigger>
    </mat-select>
  </mat-form-field>
</div>
